import type { SystemStyleObject } from '@companydotcom/potion';

const parts = ['container', 'divider', 'avatar', 'form', 'formButton', 'fields'];

const baseStyleContainer: SystemStyleObject = {
  paddingTop: 14,
  paddingBottom: '80px',
  maxWidth: 776,
  marginX: 'auto',
  paddingX: 5,
};

const baseStyleDivider: SystemStyleObject = {};

const baseStyleAvatar: SystemStyleObject = {};

const baseStyleForm: SystemStyleObject = {
  width: 'full',
  borderRadius: 'md',
  paddingTop: 7,
  paddingBottom: 10,
};

const baseStyleFormButton: SystemStyleObject = {};
const baseStyleFields: SystemStyleObject = {
  maxWidth: 424,
  mt: 3,
};

const baseStyle = () => ({
  container: baseStyleContainer,
  divider: baseStyleDivider,
  avatar: baseStyleAvatar,
  form: baseStyleForm,
  formButton: baseStyleFormButton,
  fields: baseStyleFields,
});

export default {
  parts,
  baseStyle,
};
